import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { WordmarkLogoComponent, BrandLogoComponent } from './styledComponents.js';
import useTheme from '../../hooks/useTheme.js';

var LogoComponent = function LogoComponent(_ref) {
  var ariaLabel = _ref.ariaLabel,
    type = _ref.type,
    href = _ref.href,
    onClick = _ref.onClick,
    children = _ref.children;
  var theme = useTheme();
  var sharedProps = {
    theme: theme,
    href: href,
    onClick: onClick,
    'aria-hidden': !href && !onClick,
    tabIndex: !href && !onClick ? '-1' : '0'
  };
  if (type === 'wordmark') {
    return /*#__PURE__*/React.createElement(WordmarkLogoComponent, sharedProps, children);
  }
  return /*#__PURE__*/React.createElement(BrandLogoComponent, _extends({
    "data-testid": "brand-link-or-button",
    as: href ? 'a' : 'button',
    "aria-label": ariaLabel
  }, sharedProps), children);
};
var LogoComponent$1 = LogoComponent;

export { LogoComponent$1 as default };
